/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import LazyLoad from 'react-lazyload';
import Grid from '@material-ui/core/Grid';
import { Container } from '@material-ui/core';
import withStyles from '@material-ui/core/styles/withStyles';
import { object, bool } from 'prop-types';
import YotpoHPWidget from './YotpoHPWidget';

const styles = (theme) => ({
    sliderWrapper: {
        paddingTop: '20px',
        paddingBottom: '36px',
        [theme.breakpoints.down('sm')]: {
            paddingBottom: '25px',
            paddingTop: '1rem',
        },
    },
    bannerTitle: {
        paddingBottom: '1rem',
        fontWeight: 700,
        width: '100%',
        textAlign: 'center',
        lineHeight: 1.5,
        [theme.breakpoints.down('sm')]: {
            paddingBottom: '0',
        },
    },
    sideLineWrapper: {
        width: '100%',
        textAlign: 'center',
        lineHeight: 1.5,
        position: 'relative',
        '&:before': {
            top: '10px',
            left: '0',
            width: '100%',
            content: '""',
            zIndex: '-1',
            position: 'absolute',
            borderBottom: '1px dotted #000',
        },
        '&:after': {
            background: 'black',
        },
        [theme.breakpoints.down('sm')]: {
            marginBottom: '0',
        },
    },
    sideLine: {
        padding: '0 30px',
        fontSize: '16px',
        background: '#fff',
        [theme.breakpoints.down('sm')]: {
            padding: '0 10px',
            fontSize: '15px',
        },
    },
    bottomLineTitle: {
        textAlign: 'center',
        fontWeight: 700,
        lineHeight: '24px',
    },
});

const PlantsYouLove = (props) => {
    const { isCustomerReviewPage, classes } = props;
    return (
        <Container>
            <div className={classes.sliderWrapper}>
                <Grid container alignItems="center" direction="row">
                    <Grid item md={12} xs={12}>
                        <div className={classes.bannerTitle}>
                            <p className={classes.sideLineWrapper}>
                                <span className={classes.sideLine} role="region" aria-label="SHARE THE PLANT LOVE #plantsyoulove">SHARE THE PLANT LOVE #plantsyoulove</span>
                            </p>
                        </div>
                    </Grid>
                    <Grid item md={12} xs={12}>
                        <LazyLoad><YotpoHPWidget isCustomerReviewPage={isCustomerReviewPage} /></LazyLoad>
                    </Grid>
                    <Grid item md={12} xs={12}>
                        <div className={classes.bottomLineTitle}>
                            <p><span role="region" aria-label="@plantsyoulove">@plantsyoulove</span></p>
                        </div>
                    </Grid>
                </Grid>
            </div>
        </Container>
    );
};

PlantsYouLove.propTypes = {
    classes: object.isRequired,
    isCustomerReviewPage: bool.isRequired,
};

export default withStyles(styles)(PlantsYouLove);
